/**
 * LandContingencyNote — legal's note for the vacant land offer's contingencies
 * (`WI.offer.land_contingency_note`, copy file §10; review §9.7 item 2): each
 * selected land contingency needs a deadline, and silence by the deadline
 * counts as satisfied (template 7(f)).
 *
 * Shown under the "Land & site" group of the offer wizard and in both counter
 * forms. Vacant land is a Wisconsin-only paperwork category today.
 */
import React from 'react';
import { copyText } from '../SellerDashboard/paperworkCopy';
import { CONTINGENCY_DEADLINE_NOTE } from './contingencyCatalog';
import styles from './LandContingencyNote.module.css';

export const LAND_CONTINGENCY_NOTE = copyText('WI.offer.land_contingency_note');
/** The seller's version, for a counter the seller is making. */
export const LAND_CONTINGENCY_NOTE_SELLER = copyText('WI.offer.land_contingency_note_seller');
export const CONTINGENCY_DEADLINE_NOTE_SELLER = copyText('WI.offer.contingency_deadline.note_seller');

/**
 * `WI.offer.contingency_deadline.note` (copy file §10): the same rule on a
 * Wisconsin residential or condo offer, where every selected contingency now
 * needs a deadline too (user decision).
 */
export function ContingencyDeadlineNote({ className = '', viewerRole }) {
  return (
    <p className={`${styles.note} ${className}`} role="note" data-testid="contingency-deadline-note">
      {viewerRole === 'seller' ? CONTINGENCY_DEADLINE_NOTE_SELLER : CONTINGENCY_DEADLINE_NOTE}
    </p>
  );
}

export default function LandContingencyNote({ className = '', viewerRole }) {
  return (
    <p className={`${styles.note} ${className}`} role="note" data-testid="land-contingency-note">
      {viewerRole === 'seller' ? LAND_CONTINGENCY_NOTE_SELLER : LAND_CONTINGENCY_NOTE}
    </p>
  );
}
